import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDetailsForTable, IInventoryProduct, IInventoryProductReportTotals } from "src/models/Inventory/InventoryProduct.models";
import { IInventoryProductReport } from '../../../models/Inventory/InventoryProduct.models';

interface InventoryProductState {
  movementTypes: IInventoryProduct[];
  detailsStock: IDetailsForTable[];
  availableInventory: IInventoryProductReport[];
  availableInventoryTotals: IInventoryProductReportTotals | null;
  availableInventoryToEdit: IInventoryProductReport | null;
  movementTypeToEdit: IInventoryProduct | null;
}

const initialState: InventoryProductState = {
  movementTypes: [],
  detailsStock: [],
  movementTypeToEdit: null,
  availableInventoryToEdit: null,
  availableInventory: [],
  availableInventoryTotals: null,
};

const InventoryProductSlice = createSlice({
  name: "InventoryProduct",
  initialState,
  reducers: {
    concatListInventoryProduct: (
      state: InventoryProductState,
      action: PayloadAction<IInventoryProduct[]>
      ) => {
        state.movementTypes = [...state.movementTypes.concat(action.payload)];
      },
    setInventoryProductList: (state, action: PayloadAction<IInventoryProduct[]>) => {
      state.movementTypes = action.payload;
    },
    concatProductAvailableInventoryList: (state, action: PayloadAction<IInventoryProductReport[]>) => {
      // concatenar solo aquellos que NO esten en la lista (validar por id)
      // const newAvailableInventory = action.payload.filter(
      //   item => !state.availableInventory.some(
      //     availableInventory => availableInventory.productId === item.productId
      //   )
      // );
      state.availableInventory = [...state.availableInventory.concat(action.payload)];
    },
    setProductAvailableInventoryList: (state, action: PayloadAction<IInventoryProductReport[]>) => {
      state.availableInventory = action.payload;
    },
    setProductAvailableInventoryTotals: (state, action: PayloadAction<IInventoryProductReportTotals | null>) => {
      state.availableInventoryTotals = action.payload;
    },
    setInventoryAvailableToEdit: (state, action: PayloadAction<IInventoryProductReport | null>) => {
      state.availableInventoryToEdit = action.payload;
    },
    setInventoryProductToEdit: (state, action: PayloadAction<IInventoryProduct | null>) => {
      state.movementTypeToEdit = action.payload;
    },
    setDetailsStockList: (state, action: PayloadAction<IDetailsForTable[]>) => {
      state.detailsStock = action.payload;
    },
    addInventoryProduct: (state, action: PayloadAction<IInventoryProduct>) => {
      state.movementTypes.push(action.payload);
    },
    updateInventoryProduct: (state, action: PayloadAction<IInventoryProduct>) => {
      let itemIndex = state.movementTypes.findIndex(
        item => item.movementTypeId === action.payload.movementTypeId
      );
      if (itemIndex !== -1) state.movementTypes[itemIndex] = action.payload;
    },
    updateReservedDetailsOfInventoryProduct: (state, action: PayloadAction<IDetailsForTable[]>) => {
      let itemIndex = state.availableInventory.findIndex(
        item => item.id === action.payload[0].idToConcat
      );
      if (itemIndex !== -1) state.availableInventory[itemIndex].quotationDetails = action.payload;
    },
    updateTransitDetailsOfInventoryProduct: (state, action: PayloadAction<IDetailsForTable[]>) => {
      let itemIndex = state.availableInventory.findIndex(
        item => item.id === action.payload[0].idToConcat
      );
      if (itemIndex !== -1) state.availableInventory[itemIndex].requestDetails = action.payload;
    },
    updateQuarantineDetailsOfInventoryProduct: (state, action: PayloadAction<IDetailsForTable[]>) => {
      let itemIndex = state.availableInventory.findIndex(
        item => item.id === action.payload[0].idToConcat
      );
      if (itemIndex !== -1) state.availableInventory[itemIndex].quarantineDetails = action.payload;
    },
    deleteInventoryProduct: (state, action: PayloadAction<number>) => {
      const newArray = state.movementTypes.filter(
        item => item.movementTypeId !== action.payload
      );
      state.movementTypes = newArray;
    },
  },
});

export const {
  concatListInventoryProduct,
  setInventoryProductList,
  setDetailsStockList,
  concatProductAvailableInventoryList,
  setProductAvailableInventoryList,
  setProductAvailableInventoryTotals,
  setInventoryProductToEdit,
  setInventoryAvailableToEdit,
  addInventoryProduct,
  updateInventoryProduct,
  updateReservedDetailsOfInventoryProduct,
  updateTransitDetailsOfInventoryProduct,
  updateQuarantineDetailsOfInventoryProduct,
  deleteInventoryProduct,
} = InventoryProductSlice.actions;

export default InventoryProductSlice.reducer;
